<template>
  <v-container fluid class="mt-0 pt-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card outlined>
          <v-card-title class="align-center">
            <v-btn icon class="mr-2" @click="goBack">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <h3>{{ integrationTitle }}</h3>
            <v-spacer />
            <template v-if="slug === 'opera360' && opera360Access">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    outlined
                    medium
                    color="primary"
                    class="mr-2"
                    :loading="opera360Testing"
                    v-on="on"
                    @click="testOpera360Connection"
                  >
                    <v-icon medium>mdi-connection</v-icon>
                  </v-btn>
                </template>
                <span>Testar conexão</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    outlined
                    medium
                    color="error"
                    :loading="opera360Deleting"
                    v-on="on"
                    @click="removeOpera360Access"
                  >
                    <v-icon medium>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Remover credencial</span>
              </v-tooltip>
            </template>
          </v-card-title>
          <v-card-text>
            <VivoGestaoAccessList v-if="slug === 'vivo_gestao'" />
            <Opera360AccessSettings
              v-else-if="slug === 'opera360'"
              @access-changed="onOpera360AccessChanged"
            />
            <div v-else class="text-center py-6 grey--text">
              Integração não disponível.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VivoGestaoAccessList from "./vivoGestao/VivoGestaoAccessList.vue";
import Opera360AccessSettings from "./opera360/Opera360AccessSettings.vue";

export default {
  components: {
    VivoGestaoAccessList,
    Opera360AccessSettings,
  },
  data() {
    return {
      opera360Testing: false,
      opera360Deleting: false,
    };
  },
  computed: {
    ...mapState("configurationIntegration", ["opera360Access"]),
    slug() {
      return this.$route.params.slug;
    },
    integrationTitle() {
      if (this.slug === "vivo_gestao") {
        return "Vivo Gestão";
      }

      if (this.slug === "opera360") {
        return "Opera360 API";
      }

      return "Integração";
    },
  },
  methods: {
    ...mapActions("configurationIntegration", [
      "loadOpera360Access",
      "testOpera360Access",
      "deleteOpera360Access",
    ]),
    goBack() {
      this.$router.push("/configuration_company/");
    },
    async onOpera360AccessChanged() {
      try {
        await this.loadOpera360Access();
      } catch (error) {
        this.$swal("Oops...", error.message, "error");
      }
    },
    async testOpera360Connection() {
      this.opera360Testing = true;
      try {
        const result = await this.testOpera360Access();
        const products = (result.api_product_list_json || []).join(", ");
        this.$swal(
          "Conexão realizada com sucesso",
          products ? `Produtos: ${products}` : "",
          "success"
        );
      } catch (error) {
        this.$swal("Oops...", error.message, "error");
      }
      this.opera360Testing = false;
    },
    async removeOpera360Access() {
      await this.$swal({
        icon: "warning",
        text: "Tem certeza que deseja remover a credencial Opera360?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim!",
      }).then(async result => {
        if (!result.value) {
          return;
        }

        this.opera360Deleting = true;
        try {
          await this.deleteOpera360Access();
          this.$swal("Credencial removida com sucesso", "", "success");
          await this.onOpera360AccessChanged();
        } catch (error) {
          this.$swal("Oops...", error.message, "error");
        }
        this.opera360Deleting = false;
      });
    },
  },
};
</script>
